import { render, staticRenderFns } from "./IconSvgGroup.vue?vue&type=template&id=62156a32&scoped=true&"
import script from "./IconSvgGroup.vue?vue&type=script&lang=js&"
export * from "./IconSvgGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62156a32",
  null
  
)

export default component.exports